var render = function render(){var _vm=this,_c=_vm._self._c;return _c('swiper',{class:_vm.$style.box,attrs:{"options":_vm.swiperOption}},_vm._l((_vm.hmGameList),function(item){return _c('swiper-slide',{key:item.id,class:_vm.$style['game-list'],nativeOn:{"click":function($event){return _vm.handleLinkTo(item.url)}}},[_c('img',{attrs:{"src":item.images,"alt":"游戏icon"}}),_c('div',[_vm._v(_vm._s(item.name))])])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }